import React from 'react';

import { Dropdown } from '../../../components';
import { useAuth, useTheme } from '../../../shared';
import { Badge, Button, Toggle, Popup } from '../../../components';

type UserBarProps = {};

const UserAvatar: React.FC = () => {
  const { user } = useAuth();
  if (!user) return null;

  const { picture, nickname } = user;
  const element = picture ? (
    <img src={picture} className="w-full h-full" alt="" />
  ) : (
    <Badge shrink rounded text={nickname || ''} />
  );

  return (
    <div className="ml-lg flex flex-row items-center justify-center gap-x-sm">
      <div className="font-medium text-small">{nickname}</div>
      <div className="h-[4rem] aspect-square rounded-full overflow-hidden">
        {element}
      </div>
    </div>
  );
};

const OrgSelector: React.FC = () => {
  const { orgs, organization_id, setSelectedOrg } = useAuth();
  if (!orgs || orgs.length <= 1) return null;

  return (
    <Dropdown
      value={organization_id || ''}
      onChange={value => setSelectedOrg(value)}
      options={orgs
        .map(o => ({ value: o.id, label: o.name || '' }))
        .filter(o => o.value)}
    />
  );
};

const UserBar: React.FC<UserBarProps> = () => {
  const { user, logout } = useAuth();
  const { theme, onToggle } = useTheme();
  const isDark = theme === 'dark';

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="ml-auto h-[4rem] flex items-center justify-center gap-x-sm">
      <OrgSelector />
      <Popup
        trigger={<UserAvatar />}
        popupClassName="p-md flex flex-col items-center gap-y-md rounded-sm"
      >
        <div>{user?.email}</div>
        <Toggle
          value={isDark}
          onChange={onToggle}
          label="Theme"
          labelClass="text-small"
          transitionColor={false}
        />
        <Button onClick={handleLogout} className="w-full">
          Logout
        </Button>
      </Popup>
    </div>
  );
};

export default React.memo(UserBar) as typeof UserBar;
